import { gql } from "@stadium/services/apollo-client";

export const WORKSPACE_META_DETAILS = gql`
  fragment WorkspaceMetaDetails on WorkspaceMetadata {
    companySize
    adminEmails
    formState
    packageOfferings
    team
    teamDetails
  }
`;

export const WORKSPACE_DETAILS = gql`
  fragment WorkspaceDetails on Workspace {
    id
    name
    slug
    iconUrl
    active
    unallocatedPoints
    company {
      id
      number
    }
  }
`;

export const TEAM_DETAILS = gql`
  fragment TeamDetails on Team {
    id
    name
    myWalletBalance
    unallocatedWalletBalance
    totalWalletBalance
    currencyCode
    currentUserRole
    isCurrentUserOwner
    defaultTeam
    permissions
  }
`;
